export const trackGoogleAnalyticsEvent = (event, properties = {}) => {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event,
    ...properties,
  });
};
